import { defineStore } from 'pinia'
import Vue from 'vue'
import { getLocalAcceptOddChanges, setLocalAcceptOddChanges } from '@ms/components/betslip/core/localState.js'
import { useBankerStore } from './useBanker'
import { getUofId } from './func'
import getters from './getters'
import { useSystemBetStore } from './useSystemBet'

export const useBetslipStore = defineStore('betslip', {
  state: () => ({
    // 下单期间需要锁定 betslip, 禁止操作
    loadingLock: false,
    // betslip 视图模式，支持 standard, allMultiples
    viewMode: 'standard',
    videModeOptions: Object.freeze([
      {
        text: 'Standard mode',
        value: 'standard',
        dataLabel: 'Betslip_Standard'
      },
      {
        text: 'All multiples',
        value: 'allMultiples',
        dataLabel: 'Betslip_System'
      }
    ]),
    // 可用红包数量
    vouchersCount: 0,

    // multiple+ n 值
    magicNumber: 0,
    // multiple+ 方案
    magicPlan: Number(localStorage.getItem('multiple-plus-plan')) || 1,
    planAOdds: 0,
    planBOdds: {},

    // 后台 MTS 拒绝的下单选项
    rejectSelectionsMap: {},
    // selections 状态是否发生变化(odds change || unavailable || suspended 推送变化)
    someSelectionChanged: false,
    // accept odds changes 开关
    switchAcceptOddsChanges: !!getLocalAcceptOddChanges(),

    singleStakeMap: {},
    standardMultipleStake: {}
  }),
  getters,
  actions: {
    updateLoadingLock(loading = false) {
      this.loadingLock = loading
    },

    updateViewMode(value = 'standard') {
      this.viewMode = value

      // 关闭 banker
      if (value !== 'allMultiples') {
        useBankerStore().$reset()
      }
    },

    // 更新可用红包数量
    updateVouchersCount(count = 0) {
      this.vouchersCount = count
    },

    updateMagicNumber(num = 0) {
      this.magicNumber = num
    },

    updateMagicPlan(num) {
      this.magicPlan = num
      // 记录用户上次选择
      localStorage.setItem('multiple-plus-plan', num)
    },

    updateMagicPlanOdds({ totalOddsA, totalOddsB1, totalOddsB2 }) {
      this.planAOdds = totalOddsA
      this.planBOdds = { totalOddsB1, totalOddsB2 }
    },

    setRejectSelections(list) {
      if (list) {
        this.rejectSelectionsMap = list.reduce((obj, x) => {
          const key = `${x.eventId}_${x.id}`
          obj[key] = true
          return obj
        }, {})
      }
    },
    removeRejectSelections(selection) {
      if (selection) {
        const key = `${selection.eventId}_${getUofId(selection)}`
        Vue.delete(this.rejectSelectionsMap, key)
      } else {
        this.rejectSelectionsMap = {}
      }
    },
    isRejectSelection(selection) {
      const key = `${selection.eventId}_${getUofId(selection)}`
      return !!this.rejectSelectionsMap[key]
    },

    updateSelectionChanged(status = false) {
      this.someSelectionChanged = status
    },

    // 切换 accept odds changes 开关
    toggleSwitchAcceptOddsChanges() {
      const status = !this.switchAcceptOddsChanges
      this.switchAcceptOddsChanges = status
      if (status) {
        this.someSelectionChanged = false
      }
      setLocalAcceptOddChanges(status)
    },

    resetBetslip() {
      this.updateViewMode('standard')
      this.updateSelectionChanged(false)
      this.removeRejectSelections()
      this.planAOdds = 0
      this.planBOdds = {}
    },

    // standard single selection stake 缓存
    updateSingleStake({ stake, id, count, toReturn, valid }) {
      const bet = { id, stake, count, toReturn, valid }
      Vue.set(this.singleStakeMap, id, bet)
    },

    removeSingleStake(id) {
      // 需要手动触发更新
      Vue.delete(this.singleStakeMap, id)
    },
    resetCacheStake() {
      this.singleStakeMap = {}
      this.standardMultipleStake = {}
      useSystemBetStore().$reset()
    },

    // standard 面板 multiple stake 缓存
    updateMultipleStake({ stake, count, toReturn = [], valid, bonus, betCount, totalOdds = [] }) {
      this.standardMultipleStake = { stake, count, toReturn, valid, bonus, betCount, totalOdds }
    },

    removeMultipleStake() {
      this.standardMultipleStake = {}
    }
  }
})
